import React, { useEffect, useState } from 'react';
import { Button, Image, Popconfirm, Table, message } from 'antd';
import axios from 'axios';
import { getDataCallResult } from '../components/CommonApiCall';
import { fileUrl, baseUrl } from '../constants/const';
import AddTipModal from '../Modals/AddTipModal';

const TipsandInfo = () => {
    const [loading, setLoading] = useState(false);
    const [tipsData, setTipsData] = useState([]);
    const [openAddTip, setOpenAddTip] = useState(false);
    const [openEditAddTip, setOpenEditAddTip] = useState(false);
    const [selectedTip, setSelectedTip] = useState(null);
    console.log('selectedTip', selectedTip)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 6,
        total: 0,
    });

    const getData = () => {
        setLoading(true);

        getDataCallResult(
            pagination.current,
            pagination.pageSize,
            '',
            '/admin/get_tips_list',
            (res) => {
                setLoading(false);
                setTipsData(res?.data?.data || []);
                setPagination((p) => ({
                    ...p,
                    total: res?.data?.other?.total_entries || 0,
                }));
            },
            () => {
                setLoading(false);
                setTipsData([]);
            }
        );
    };
    const handleEdit = (record) => {
        console.log('record', record)
        setSelectedTip(record)
        setOpenEditAddTip(true)
    }
    const handleDelete = async (id) => {
        try {
            await axios.delete(`${baseUrl}/admin/delete_tips`, {
                data: { _id: id }   // 👈 MUST be inside `data`
            });

            message.success("Tip deleted");
            getData();
        } catch (error) {
            message.error("Delete failed");
        }
    };


    const columns = [
        {
            title: 'Media',
            dataIndex: 'media_url',
            align: 'center',
            render: (url, record) => {
                if (!url) return '—';

                const mediaType = record?.media_type; // image | video | audio
                const src = `${fileUrl}${url}`;

                if (mediaType === 'video') {
                    return (
                        <video
                            width={80}
                            height={70}
                            className="rounded-3"
                            controls
                        >
                            <source src={src} />
                        </video>
                    );
                }

                if (mediaType === 'audio') {
                    return (
                        <audio
                            controls
                            style={{ width: 160 }}
                        >
                            <source src={src} />
                        </audio>
                    );
                }

                // default → image
                return (
                    <Image
                        className="rounded-3"
                        src={src}
                        height={60}
                        width={60}
                        preview
                    />
                );
            },
        },        
        { title: 'Tip', dataIndex: 'tips' },
        { title: 'Information', dataIndex: 'information' },

        {
            title: 'Action',
            align: 'center',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 10 }} className="">
                    <Button style={{
                        width: 90
                    }} className='' onClick={() => handleEdit(record)}>
                        Edit
                    </Button>
                    <Popconfirm
                        title="Delete this tip?"
                        description="Are you sure you want to delete this tip?"
                        okText="Yes, Delete"
                        cancelText="Cancel"
                        okButtonProps={{ danger: true }}
                        onConfirm={() => handleDelete(record._id)}
                    >
                        <Button danger>
                            Delete
                        </Button>
                    </Popconfirm>

                </div>
            ),
        }

    ];

    useEffect(() => {
        getData();
    }, [pagination.current]);

    return (
        <div>
            <div className='d-flex mb-3 justify-content-between flex-column flex-md-row '>
                <h5 className=''>Tips & Informations</h5>
                <div className="">
                    <Button className='purpleButton ' onClick={() => setOpenAddTip(true)}>Add New</Button>
                </div>
            </div>

            <Table
                loading={loading}
                dataSource={tipsData}
                columns={columns}
                scroll={{ x: 250 }}
                rowKey="_id"
                pagination={{
                    ...pagination,
                    onChange: (page) =>
                        setPagination((p) => ({ ...p, current: page })),
                }}
            />


            {/* //! Add modal */}
            <AddTipModal
                open={openAddTip}
                onCancel={() => { setOpenAddTip(false); setSelectedTip(null) }}
                onSuccess={getData}
            />
            {/* //! Edit modal */}
            <AddTipModal
                isEdit={true}
                open={openEditAddTip}
                selectedtip={selectedTip}
                onCancel={() => { setOpenEditAddTip(false); setSelectedTip(null) }}
                onSuccess={getData}
            />
        </div>
    );
};

export default TipsandInfo;
